import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import SessionStatusButton from '../SessionStatusButton';
import StudentParticipation from '../StudentParticipation';
import { fetchStudentAttendance } from '../../../action/educator/AppointmentAction';
import { PATH } from '../../../../utils/Constants';
import { BRANCH_ADMIN_ROUTES_SECONDARY_PATH } from '../../../../utils/routes/path';
import {
    BroadCastSession,
    ClassroomSession,
    InPerson,
    Scheduled,
    Tutor,
} from '../../../../utils/common/NamingTerms';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';

class FinancialReportTableComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            studentParticipationModal: false,
            studentAttendanceDetails: [],
            currentPage: 0,
            isStudentListLoading: false,
            isBroadcast: false,
            itemsPerPage: 10,
            totalPages: 0,
        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    // Handle  Page change
    handlePageChange(event) {
        this.setState(
            { currentPage: Number(event.selected) },
            this.fetchStudentAttendance(
                this.state.searchValue,
                Number(event.selected),
                10,
                this.state.sessionId
            )
        );
    }

    // Fetch Student Attendance Details
    fetchStudentAttendance(search, currentPage, itemsPerPage, sessionId) {
        this.setState({ isStudentListLoading: true });
        let values = {
            search: search,
            pageNumber: currentPage + 1,
            itemsPerPage,
            sessionId: sessionId,
        };
        this.props.fetchStudentAttendance(values, (result) => {
            this.setState({ isStudentListLoading: false, sessionId: sessionId });
            if (result) {
                this.setState({
                    studentAttendanceDetails: result.response.data,
                    totalPages: result.response.totalPages,
                });
            } else {
                this.setState({ totalPages: 0 });
            }
        });
    }

    // Navigate to respective detail screen with Visit ID
    navigateToDetailScreen = (type, visitId) => {
        if (type === 'waitingRoom') {
            this.props.history.push(
                `${PATH.IM_PHYSICIAN.WAITINGROOM}/${this.props.match.params.userId}/${visitId}`
            );
        }
    };

    // handleSearchUser
    handleSearchUser = (event) => {
        const searchValue = event.target.value;
        this.setState({ searchValue });
        clearTimeout(this.state.timeout);
        const timeout = setTimeout(() => {
            this.fetchStudentAttendance(this.state.searchValue, 0, 1000, this.state.sessionId);
        }, 1000); // 1Sec delay before triggering the search
        this.setState({ timeout });
    };

    render() {
        return (
            <div className="overflow-x-auto bg-white rounded-lg border-black-10">
                <table className="w-full table-bordered">
                    <thead className="text-left text-primary border-bottom whitespace-nowrap">
                        <tr>
                            <th scope="col" className="p-3 font-medium">
                                Subject
                            </th>
                            <th scope="col" className="p-3 font-medium">
                                Subcategory
                            </th>
                            <th scope="col" className="p-3 font-medium">
                                Session Type
                            </th>
                            <th scope="col" className="p-3 font-medium">
                                Students
                            </th>
                            <th scope="col" className="p-3 font-medium">
                                Session Time
                            </th>
                            <th scope="col" className="p-3 font-medium">
                                Session Status
                            </th>
                            <th scope="col" className="p-3 font-medium text-end">
                                Amount
                            </th>
                            {(this.props.data.role === RESPONSE_CONSTANT.BRANCHADMIN ||
                                this.props.data.role === Tutor) && (
                                <th scope="col" className="p-3 font-medium text-center">
                                    Action
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody className="break-word">
                        {this.props.CustomerFinancialReportsData &&
                        this.props.CustomerFinancialReportsData.length ? (
                            <>
                                {this.props.CustomerFinancialReportsData.map((value, index) => {
                                    return (
                                        <tr key={index} className="border-bottom whitespace-nowrap">
                                            <td className="p-3 table-ellipse">
                                                {value.subject
                                                    ? value.subject
                                                    : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                            </td>
                                            <td className="p-3 table-ellipse">
                                                {value.subCategory
                                                    ? value.subCategory
                                                    : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                            </td>
                                            {value.sessionType === Scheduled ? (
                                                <td className="p-3 text-cyan">Appointment</td>
                                            ) : value.sessionType === ClassroomSession ? (
                                                <td className="p-3 text-cyan">Classroom</td>
                                            ) : value.sessionType === BroadCastSession ? (
                                                <td className="p-3 text-cyan">
                                                    Live Stream Broadcast
                                                </td>
                                            ) : value.sessionType === InPerson ? (
                                                <td className="p-3 text-orange">In Person</td>
                                            ) : (
                                                <td className="p-3 text-orange">On Demand</td>
                                            )}
                                            <td className="p-3" title={value.students}>
                                                {value.students.length > 15
                                                    ? `${value.students.slice(0, 15)}...`
                                                    : value.students}
                                                {value.sessionType === ClassroomSession ||
                                                value.sessionType === BroadCastSession ? (
                                                    <>{value.studentCount > 1 ? ',' : ''}</>
                                                ) : null}
                                                {value.studentCount > 1 && (
                                                    <span
                                                        onClick={() => {
                                                            this.fetchStudentAttendance(
                                                                this.state.searchValue,
                                                                this.state.currentPage,
                                                                this.state.itemsPerPage,
                                                                value.visitId
                                                            );
                                                            this.setState({
                                                                studentParticipationModal: true,
                                                                isBroadcast:
                                                                    value.sessionType ===
                                                                    BroadCastSession,
                                                            });
                                                        }}
                                                        style={{
                                                            color: 'rgb(40,35,92)',
                                                            fontWeight: '600',
                                                        }}
                                                        className="cursor-pointer"
                                                    >
                                                        {' '}
                                                        More ...
                                                    </span>
                                                )}
                                            </td>
                                            <td className="p-3 table-ellipse">
                                                {' '}
                                                {moment(value.sessionDate).format(
                                                    'MMM DD, YYYY hh:mm A'
                                                )}
                                            </td>
                                            <td className="p-3 table-ellipse">
                                                <SessionStatusButton
                                                    status={value.sessionStatus}
                                                    institutionList={[]}
                                                />
                                            </td>
                                            <td className="p-3 table-ellipse text-end">
                                                {value.amount}
                                            </td>
                                            {this.props.data.role ===
                                                RESPONSE_CONSTANT.BRANCHADMIN && (
                                                <td className="p-3 text-center table-ellipse">
                                                    <Link
                                                        to={`${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.BRANCH_ADMIN}/${this.props.userId}${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.SUMMARY}/${value.visitId}`}
                                                        style={{ color: 'rgb(40,35,92)' }}
                                                    >
                                                        <i className="fa-regular fa-eye"></i>
                                                    </Link>
                                                </td>
                                            )}
                                            {this.props.data.role === Tutor && (
                                                <td className="p-3 text-center table-ellipse">
                                                    <Link
                                                        to={`${PATH.IM_PHYSICIAN.WAITINGROOM}/${this.props.userId}/${value.visitId}`}
                                                        style={{ color: 'rgb(40,35,92)' }}
                                                    >
                                                        <i className="fa-regular fa-eye"></i>
                                                    </Link>
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                            </>
                        ) : (
                            <tr>
                                <td colSpan="8" className="p-3 text-center text-white">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <StudentParticipation
                    openModal={this.state.studentParticipationModal}
                    closeModal={() => {
                        this.setState({
                            studentParticipationModal: false,
                            currentPage: 0,
                            searchValue: '',
                        });
                    }}
                    studentAttendanceDetails={this.state.studentAttendanceDetails}
                    isLoading={this.state.isStudentListLoading}
                    pageDisplayCount={this.state.totalPages}
                    currentPage={this.state.currentPage}
                    handlePageChange={(e) => {
                        this.handlePageChange(e);
                    }}
                    onChange={(e) => this.handleSearchUser(e)}
                    isFromAdmin={true}
                    hideStatus={false}
                    isBroadcastSession={this.state.isBroadcast}
                />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchStudentAttendance: (values, callback) => {
            dispatch(fetchStudentAttendance(values, callback));
        },
    };
};

export default connect(null, mapDispatchToProps)(FinancialReportTableComponent);
